import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CalendersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CreateCalenderEventCommand,
  UpdateCalenderEventCommand,
} from '../../../../core/api/models';
import { UtilityService } from '../../../../core/services/utility.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";

@Component({
    selector: 'app-calendar-form',
    templateUrl: './calendar-form.component.html',
    styleUrls: ['./calendar-form.component.scss'],
    standalone: false
})
export class CalendarFormComponent
  extends BaseFormPageComponent
  implements OnInit, AfterViewInit
{
  //#region Properties
  title: string;
  model: CreateCalenderEventCommand = {};
  formPageConfig: FormPageConfig<any> = {};
  eventId: number;
  isCalenderEventMode: boolean = false;
  //#endregion

  constructor(
    protected currentService: CalendersService,
    public UtilityService: UtilityService,

    private dialogRef: MatDialogRef<CalendarFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    if (data.model) this.model = Object.assign({}, data?.model);
    this.eventId = data?.model?.id;
    this.model.calenderId = data?.calendarId;

    if (data?.calenderEventType == 'calendarEvent') {
      this.isCalenderEventMode = true;
      this.model.isHoliday = data?.isHoliday;
    }
  }

  ngOnInit() {
    try {
      this.initForm();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(Validators.required),
      description: new FormControl(Validators.required),
      category: new FormControl(Validators.required),
      isHoliday: new FormControl(''),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateCalenderEventCommand) {
    this.unSubs();

    this.loading = true;
    if (this.isCalenderEventMode) {
      this.currentService
        .calendersCreateCalenderEventPost({ body: model })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseObserver);
    } else {
      this.currentService
        .calendersCreateCalenderOrganizationEventPost({ body: model })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseObserver);
    }
  }

  //Update
  baseUpdateApi(model: UpdateCalenderEventCommand) {
    this.unSubs();
    this.loading = true;

    model.id = this.eventId;
    if (this.isCalenderEventMode) {
      this.currentService
        .calendersUpdateCalenderEvent({ body: model })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseObserver);
    } else {
      this.currentService
        .calendersUpdateCalenderOrganizationEvent({ body: model })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseObserver);
    }
  }

  //#endregion

  //#region final methods

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.unSubs();
    this.dialogRef.close(true);
  }

  //#endregion
}
